import { render, staticRenderFns } from "./ConciergeProducts.vue?vue&type=template&id=0f6ec3ee&scoped=true"
import script from "./ConciergeProducts.ts?vue&type=script&lang=ts&external"
export * from "./ConciergeProducts.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ec3ee",
  null
  
)

export default component.exports